/**
 * @file Contributor assignments related mutations.
 */

import gql from 'graphql-tag';

import {
  ContributorAssignmentBaseDetails,
  ContributorAssignmentShareBaseDetails,
} from '../fragments/contributor-assignments';

export const contributorAssignmentShareCreate = gql`
  mutation contributorAssignmentShareCreate(
    $input: ContributorAssignmentShareCreateInput!
  ) {
    contributorAssignmentShareCreate(input: $input) {
      contributor_assignment {
        ...ContributorAssignmentBaseDetails
      }
      contributor_assignment_share {
        ...ContributorAssignmentShareBaseDetails
      }
    }
  }
  ${ContributorAssignmentBaseDetails}
  ${ContributorAssignmentShareBaseDetails}
`;

export const contributorAssignmentShareUpdate = gql`
  mutation contributorAssignmentShareUpdate(
    $input: ContributorAssignmentShareUpdateInput!
  ) {
    contributorAssignmentShareUpdate(input: $input) {
      contributor_assignment_share {
        ...ContributorAssignmentShareBaseDetails
      }
    }
  }
  ${ContributorAssignmentShareBaseDetails}
`;

export const contributorAssignmentShareDelete = gql`
  mutation contributorAssignmentShareDelete(
    $input: ContributorAssignmentShareDeleteInput!
  ) {
    contributorAssignmentShareDelete(input: $input) {
      success
    }
  }
`;

export const contributorAssignmentUpdate = gql`
  mutation contributorAssignmentUpdate(
    $input: ContributorAssignmentUpdateInput!
  ) {
    contributorAssignmentUpdate(input: $input) {
      contributor_assignment {
        ...ContributorAssignmentBaseDetails
      }
    }
  }
  ${ContributorAssignmentBaseDetails}
`;

export const contributorAssignmentsUpdate = gql`
  mutation contributorAssignmentsUpdate(
    $input: ContributorAssignmentsUpdateInput!
  ) {
    contributorAssignmentsUpdate(input: $input) {
      success
    }
  }
`;

export const contributorAssignmentDelete = gql`
  mutation contributorAssignmentDelete(
    $input: ContributorAssignmentDeleteInput!
  ) {
    contributorAssignmentDelete(input: $input) {
      success
    }
  }
`;

export const autoContributorInvitationsSend = gql`
  mutation autoContributorInvitationsSend(
    $input: AutoContributorInvitationsSendInput!
  ) {
    autoContributorInvitationsSend(input: $input) {
      success
    }
  }
`;

export const autoContributorInvitationResend = gql`
  mutation autoContributorInvitationResend(
    $input: AutoContributorInvitationResendInput!
  ) {
    autoContributorInvitationResend(input: $input) {
      success
    }
  }
`;

export const autoContributorInvitationView = gql`
  mutation autoContributorInvitationView(
    $input: AutoContributorInvitationViewInput!
  ) {
    autoContributorInvitationView(input: $input) {
      success
    }
  }
`;
